export const formatPack = (pack, credits) => {
	if (!pack) {
		return '-';
	}
	return typeof credits === 'number' ? `${pack} - ${credits.toLocaleString('en-US')} credits` : pack;
};
